import { render, staticRenderFns } from "./FixedBottom.vue?vue&type=template&id=c007375e&scoped=true"
import script from "./FixedBottom.vue?vue&type=script&lang=js"
export * from "./FixedBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c007375e",
  null
  
)

export default component.exports